var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "d-flex px-4" }, [
    _c("div", { staticClass: "w-25 p-1" }, [
      _vm._v(" \n    " + _vm._s(_vm.date) + "\n  "),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "w-25 p-1" }, [
      _vm._v(
        _vm._s(_vm.subscriptionInvoice.amountPaid.toLocaleString()) + "円"
      ),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "w-25 p-1", style: { minWidth: "100px" } },
      [
        _c(
          "v-chip",
          {
            staticClass: "me-2 text-white",
            attrs: { color: "blue", small: "", label: "" },
          },
          [_vm._v("\n      支払い済み\n    ")]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }